import { Message } from '../../MessageBus/Message';

export class MoveCommand extends Message
{
    constructor(
        Id: string,
        From: string,
        To: string)
    {
        super("Move", { Id, From, To });
    }
}
